
import {
  Downloader,
  EVENT_TYPES,
  Parser,
  Player,
  VideoEntity,
} from "svga.lite";
import {
  defineComponent,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
} from "vue";

const downloader = new Downloader();
let needMount = false;

export default defineComponent({
  name: "app-svga",
  props: {
    src: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      parser: null,
      player: null as null | Player,
      svgaData: null as null | VideoEntity,
      isMount: false,
      canPlay: false,
      needPlay: false,
      parseEnd: false,
      canMount: false,
    });
    const canvas = ref();

    onMounted(svgaMounted);

    async function svgaMounted() {
      const player = (state.player = new Player(canvas.value));
      const {
        loop = 0,
        fillMode = "forwards",
        playMode = "forwards",
        startFrame = 0,
        endFrame = 0,
        autoPlay = true,
        autoMount = true,
      } = props.options;
      player.set({
        loop,
        fillMode,
        playMode,
        startFrame,
        endFrame,
        cacheFrames: true,
        intersectionObserverRender: true,
      });
      state.svgaData = await parseSvgaData(props.src);
      emit("parsed");
      state.parseEnd = true;
      needMount && (await mount(false));
      // 事件回调
      player
        .$on("start" as EVENT_TYPES.START, () => emit("start"))
        .$on("pause" as EVENT_TYPES.PAUSE, () => emit("pause"))
        .$on("stop" as EVENT_TYPES.STOP, () => emit("stop"))
        .$on("end" as EVENT_TYPES.END, () => emit("end"))
        .$on("clear" as EVENT_TYPES.CLEAR, () => emit("clear"))
        .$on("process" as EVENT_TYPES.PROCESS, () =>
          emit("process", player.progress)
        )
        .$on("resume" as EVENT_TYPES.RESUME, () => emit("resume"));
      if (autoMount) {
        await mount(autoPlay);
        state.canPlay = true;
        // 如果start函数在mount结束前被调用，待绑定完成后直接播放
        if (state.needPlay) {
          start();
        }
      } else if (autoPlay) {
        start();
      }
    }

    async function parseSvgaData(src: string) {
      const parser = new Parser();
      const rawData = await downloader.get(src);
      return await parser.do(rawData);
    }

    async function mount(autoPlay: boolean) {
      let result;
      if (state.parseEnd && state.player) {
        result = await state.player.mount(state.svgaData as VideoEntity);
        state.canPlay = state.isMount = true;
        if (state.needPlay || autoPlay) {
          state.player && state.player.start();
        }
      } else {
        needMount = true;
      }
      return result;
    }

    function start() {
      if (!state.player) {
        return;
      }
      if (state.canPlay) {
        state.player.start();
      } else {
        state.needPlay = true;
      }
    }

    function pause() {
      if (state.player) state.player.pause();
    }

    function stop() {
      if (state.player) state.player.stop();
    }
    function resume() {
      if (state.player) state.player.resume();
    }
    function clear() {
      if (state.player) {
        state.player.clear();
        state.player = state.svgaData = null;
      }
    }
    onBeforeUnmount(clear);

    return {
      canvas,
      start,
      resume,
      stop,
      pause,
    };
  },
});
